import React, { useState } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEllipsisV, faTrash } from '@fortawesome/free-solid-svg-icons';
import { useProjectDetailsContext } from '../contexts/ProjectDetailsContext';
import { useLabelContext } from '../contexts/LabelContext';
import StatusIndicator from './StatusIndicator';
import ApprovalStatusModal from './ApprovalStatusModal';
import EllipsisOptions from './EllipsisOptions';

const LabelDetailControls: React.FC = () => {
    const {
        state: { project },
    } = useProjectDetailsContext();
    const {
        state: { labelDetailed },
    } = useLabelContext();

    const {
        handlers: { handleLabelDelete },
    } = useProjectDetailsContext();

    const approvalStages = project?.workflow.stages;
    const [editApprovalStatus, setEditApprovalStatus] = useState(false);

    return (
        <>
            <ApprovalStatusModal
                isActive={editApprovalStatus}
                onClose={() => setEditApprovalStatus(false)}
            />
            <div className="controls">
                {labelDetailed &&
                    approvalStages &&
                    approvalStages.length === 0 && (
                        <StatusIndicator
                            decision={labelDetailed.approval_status}
                            isBig={true}
                            onEdit={() => setEditApprovalStatus(true)}
                        />
                    )}
                <EllipsisOptions
                    size="large"
                    options={[
                        {
                            icon: faTrash,
                            label: 'Delete',
                            onClick: () => handleLabelDelete(labelDetailed.id),
                            variant: 'danger',
                        },
                    ]}
                />
            </div>
        </>
    );
};

export default LabelDetailControls;
